// Format an ISO timestamp as "hace 5 min", "hace 2 h", "hace 3 d".
// Non-locale-aware but Spanish-friendly and dependency-free.
export function formatRelativeShortEs(iso) {
  if (!iso) return null;
  const d = typeof iso === "string" ? new Date(iso) : iso;
  const ms = Date.now() - d.getTime();
  if (Number.isNaN(ms) || ms < 0) return null;
  const sec = Math.floor(ms / 1000);
  if (sec < 45) return "hace unos segundos";
  const min = Math.floor(sec / 60);
  if (min < 60) return `hace ${min} min`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `hace ${hr} h`;
  const day = Math.floor(hr / 24);
  if (day < 30) return `hace ${day} d`;
  const mo = Math.floor(day / 30);
  if (mo < 12) return `hace ${mo} m`;
  const yr = Math.floor(mo / 12);
  return `hace ${yr} a`;
}
